import { useEffect } from "react";
import useBoundStore from "store";

export default function AppFocus() {
  const setMiscellaneous = useBoundStore((state) => state.miscellaneous.set);

  const setTabFocused = () => {
    setMiscellaneous({ isAppFocused: true });
  };

  const setTabBlurred = () => {
    setMiscellaneous({ isAppFocused: false });
  };

  useEffect(() => {
    window.addEventListener("focus", setTabFocused);
    window.addEventListener("blur", setTabBlurred);

    return () => {
      window.removeEventListener("focus", setTabFocused);
      window.removeEventListener("blur", setTabBlurred);
    };
  }, []);

  return null;
}
